import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

const Hero = () => {
  return (
    <Container id="terms-hero">
      <Box sx={{ height: 400, my: 5 }}>
        <Box
          component={'img'}
          src={
            'https://cdn.pixabay.com/photo/2017/08/30/07/56/money-2696228_960_720.jpg'
          }
          alt="Terms and Conditions"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: 2,
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ justifyContent: 'left' }}>
          <Typography
            variant="h3"
            sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
          >
            Terms and Conditions
          </Typography>
          <Typography variant="h6" sx={{ textAlign: 'left', my: 2 }}>
            Last updated June 11, 2024
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
          >
            Introduction
          </Typography>
          {[
            `Welcome to Topibro Technologies ("Topibro Tech", "we", "us", or "our"). By accessing or using our website, services, products, or any content made available by Topibro Technologies, you agree to be bound by these Terms and Conditions. Please read them carefully before proceeding.`,
            `These Terms and Conditions govern your use of our website located at www.topibrotech.com and all related services provided by Topibro Technologies, including but not limited to web development, mobile application development, web design, training programs, co-working space, and online learning platforms.`,
            `If you do not agree with any part of these terms, you must not use our services. Your continued use of our website or services following any modifications to these Terms constitutes your acceptance of the revised Terms.`,
          ].map((text, i) => (
            <Typography
              key={i}
              variant="h6"
              sx={{
                fontWeight: 400,
                textAlign: 'left',
                my: 2,
                color: 'text.secondary',
              }}
            >
              {text}
            </Typography>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default Hero;
